import { createContext, useContext } from 'react';
import { CatalogContextProps } from './Catalog.types';

export const CatalogContext = createContext<CatalogContextProps | undefined>(undefined);
CatalogContext.displayName = 'CatalogProvider';

export const useCatalogContext = () => {
  const context = useContext(CatalogContext);
  if (context === undefined) {
    throw new Error('useCatalogContext must be used within a CatalogProvider');
  }
  return context;
};
